import { RowHeights } from '@core/config/row-heights';
import { Department } from '@portal-shared/app/entities/department.model';
import { ViewByEnum } from '@portal-shared/app/enums/view-by.enum';
import { FormatUtils } from '@portal-shared/app/utils/format.utils';
import { DepartmentGroupRowDto } from '@services/dtos/rows/department-group-row.dto';
import { AssignmentGroupDefinition } from '@services/models/group-definition.model';
import { PlanningBoardGroupRowType } from '@shared/components/grids/rows/groups/planning-board-group-row-type.enum';
import { SortModelItem } from 'ag-grid-community';
import { PlanningGroupRow } from './planning-group.row';

export class DepartmentGroupRow extends PlanningGroupRow {
  public override type = PlanningBoardGroupRowType.Department;
  public override height = RowHeights.planningGrid.rowMedium;
  public override isRowDroppable = false;
  public override styleClasses = [];
  public department: Department;

  public constructor(
    public dto: DepartmentGroupRowDto,
    public override projectId: string,
    public override departmentId: string = dto.departmentId
  ) {
    super(dto, projectId, departmentId);

    this.department = new Department(dto.departmentId, dto.departmentCode, dto.departmentDescription);
    this.label = this.department.label;
  }

  public override toGroupDefinition(): AssignmentGroupDefinition {
    return {
      projectId: this.projectId,
      departmentId: this.departmentId
    };
  }

  public static getDefaultSortModel(): SortModelItem[] {
    const codeItem: SortModelItem = { colId: 'departmentCode', sort: 'asc' };
    const descItem: SortModelItem = { colId: 'departmentDescription', sort: 'asc' };

    switch (FormatUtils.viewBy) {
      case ViewByEnum.viewByCode:
        return [codeItem];
      case ViewByEnum.viewByDescription:
        return [descItem];
      case ViewByEnum.viewByCodeDescription:
        return [codeItem, descItem];
    }
  }
}
